module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "box header"
  }, [_vm._v("Hyreshjälpen")]), _vm._v(" "), _c('div', {
    staticClass: "box sidebar"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Hyreshjälpen")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/hyra-ut-bostadsratt'
    }
  }, [_vm._v("Hyra ut bostadsrätt")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/kostnadsbaserad-hyra'
    }
  }, [_vm._v("Kostnadsbaserad hyra")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/hyra-ut-rum'
    }
  }, [_vm._v("Hyr ut rum")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "box footer"
  }, [_vm._v("Hyreshjälpen är en gratis sajt för att informera om hyrestagares rättigheter.")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0e1ab5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 23
// module chunks = 0